import axios from 'axios';

export const api = (apiSecret, apiUrl) =>
  axios.create({
    baseURL: apiUrl,
    headers: {
      Authorization: apiSecret,
    },
  });
